import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.team.form.component.html"
    ,providers: []
})
export class DtgManageTeamFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() companyId:string;
    @Input() teamId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    currentUserInfo:any;
    userGroupId:number;
    
    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
     }

    ngOnInit() {
        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.selectOneTeamInfo();
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.selectOneTeamInfo();
                this.formGroup.disable();
                break;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            dtgTeamId:null
            ,dtgTeamNm:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,companyId:[
                this.companyId
                ,[
                    Validators.required
                ]
            ]
            ,companyNm:null
            ,lat:null
            ,lng:null
            ,addr1:null
            ,useYn:"Y"
        });
    }

    get f() { return this.formGroup.controls; }

    selectOneTeamInfo(){
        let searchInfo = {
            companyId : this.companyId
            ,dtgTeamId : this.teamId
        };
        this.fvmsApiDtgTeamService.getOneTeam(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.formGroup.patchValue(apiResponse.resultValue);
                }
            });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f);
        if (this.formGroup.invalid) {
            return;
        }

        let teamInfo = {
            dtgTeamId:this.f.dtgTeamId.value
            ,dtgTeamNm:this.f.dtgTeamNm.value
            ,companyId:this.f.companyId.value
            ,lat:this.f.lat.value
            ,lng:this.f.lng.value
            ,addr1:this.f.addr1.value
            ,useYn:this.f.useYn.value
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
        };
        console.log("onSubmit",teamInfo);

        this.fvmsApiDtgTeamService.upsertTeam(teamInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    console.log("new team id",apiResponse.resultValue.dtgTeamId);
                }

                this.activeModal.close({
                    "result":"ok"
                });
            });
        return;
    }
}